import * as React from "react";
const SvgVectorHowItsWork = (props) => /* @__PURE__ */ React.createElement("svg", { width: 1101, height: 227, viewBox: "0 0 1101 227", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "grad1", x1: "0%", y1: "0%", x2: "100%", y2: "0%" }, /* @__PURE__ */ React.createElement("stop", { offset: "0%", style: {
  stopColor: "white",
  stopOpacity: 5e-3
} }), /* @__PURE__ */ React.createElement("stop", { offset: "70%", style: {
  stopColor: "white",
  stopOpacity: 0.04
} }), /* @__PURE__ */ React.createElement("stop", { offset: "100%", style: {
  stopColor: "black",
  stopOpacity: 0
} }))), /* @__PURE__ */ React.createElement("rect", { width: 1101, height: 227, fill: "url(#grad1)" }));
export default SvgVectorHowItsWork;
